export const ipad = {
  id: 'ipad',
  label: 'iPad',
  emoji: '📟',
  colorScheme: 'cyan',
  description: 'iPad & iPad Pro app icons',
  folder: 'ios/AppIcon.appiconset',
  icons: [
    { filename: 'Icon-20@1x-ipad.png',   size: 20,  pointSize: 20,   scale: 1, idiom: 'ipad', label: 'Notification @1x' },
    { filename: 'Icon-20@2x-ipad.png',   size: 40,  pointSize: 20,   scale: 2, idiom: 'ipad', label: 'Notification @2x' },
    { filename: 'Icon-29@1x-ipad.png',   size: 29,  pointSize: 29,   scale: 1, idiom: 'ipad', label: 'Settings @1x' },
    { filename: 'Icon-29@2x-ipad.png',   size: 58,  pointSize: 29,   scale: 2, idiom: 'ipad', label: 'Settings @2x' },
    { filename: 'Icon-40@1x-ipad.png',   size: 40,  pointSize: 40,   scale: 1, idiom: 'ipad', label: 'Spotlight @1x' },
    { filename: 'Icon-40@2x-ipad.png',   size: 80,  pointSize: 40,   scale: 2, idiom: 'ipad', label: 'Spotlight @2x' },
    { filename: 'Icon-76@1x-ipad.png',   size: 76,  pointSize: 76,   scale: 1, idiom: 'ipad', label: '@1x' },
    { filename: 'Icon-76@2x-ipad.png',   size: 152, pointSize: 76,   scale: 2, idiom: 'ipad', label: '@2x' },
    { filename: 'Icon-83.5@2x-ipad.png', size: 167, pointSize: 83.5, scale: 2, idiom: 'ipad', label: 'iPad Pro @2x' },
  ],
};
